import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';
import { NewApprovedPayer } from '../models/approved-payer';

@Injectable({
    providedIn: 'root'
  })

  export class ApprovedPayerService
  {
    private customerApi = environment.customerApiUrl;

    constructor(private http: HttpClient) {
    }

    public saveNewPayer(approvedPayer: NewApprovedPayer): Observable<any> {
        return this.http.post(`${this.customerApi}/ApprovedPayer/add-payer`, approvedPayer);
    }

    public getPayerList(getPayerByName): Observable<any> {
      return this.http.post(`${this.customerApi}/ApprovedPayer/list-payers`, getPayerByName);
    }
  }